"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import { GroupedCardCarouselProps } from "./types";
import HelpCard from "../HelpCard";
import { HelpCardProps } from "../HelpCard";

const chunkCards = (arr: HelpCardProps[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

const GroupedHelpCardsCarousel = ({
  className,
  cards,
}: GroupedCardCarouselProps) => {
  const cardChunks = chunkCards(cards, 6);
  return (
    <Carousel.Mobile
      options={{
        slides: {
          spacing: 24,
          perView: "auto",
        },
      }}
      showPagination
      className={cn(
        "md:!grid md:!grid-cols-2 md:!gap-4 lg:!grid-cols-3 md:!overflow-visible",
        className
      )}
    >
      {cardChunks.map((chunk, chunkIndex) => (
        <CarouselSlide
          key={`chunk-${chunkIndex}`}
          className="!min-w-full !w-full !md:min-w-auto md:!w-auto grid grid-cols-2 gap-4 md:!contents md:!gap-0"
        >
          {chunk.map(({ title, iconId, iconSizes }, i) => (
            <HelpCard
              key={i}
              iconId={iconId}
              iconSizes={iconSizes}
              title={title}
              className="md:flex-auto md:min-w-0"
            />
          ))}
        </CarouselSlide>
      ))}
    </Carousel.Mobile>
  );
};

export default memo(GroupedHelpCardsCarousel);
